module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAaBAMAAAC0pjrDAAAAElBMVEUAAACRkZGRkZGSkZGSkZGSkZHFjS5fAAAABXRSTlMAYF/v31EnuFkAAABxSURBVBjTRc8xDoAgEETRQTmAjT2NPYUHIPEEmuz9r2Lww0i15BX7V8tZxPvGHM/8HlG1RpSBEU0pOoOxSXtn8JZgI2yEf4RBM2gGzaDZyE52u5Y0o5kg0nxKMhNkJgieCBvhieYMwlUrCDela6D6+AL3fynoLs/GewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/close.png
// module id = YxG/
// module chunks = 0